import { render, staticRenderFns } from "./LanguagesMenu.vue?vue&type=template&id=c4567288&scoped=true"
import script from "./LanguagesMenu.vue?vue&type=script&lang=js"
export * from "./LanguagesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4567288",
  null
  
)

export default component.exports